import { PLAY_STORE_URL } from './InstallPWAButton';

const Triangle = ({ size = 22 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#00C4FF" d="M3.6 1.9c-.4.4-.6 1-.6 1.7v16.8c0 .7.2 1.3.6 1.7l.1.1 9.9-9.9v-.5L3.7 1.8l-.1.1z" />
        <path fill="#FFCE00" d="M16.9 15.6l-3.3-3.3v-.5l3.3-3.3h.1l3.9 2.2c1.1.6 1.1 1.7 0 2.3l-3.9 2.2h-.1z" />
        <path fill="#F43E5C" d="M17 15.5l-3.4-3.4-10 10c.4.4 1 .4 1.7 0L17 15.5z" />
        <path fill="#00E076" d="M17 8.5L5.3 1.9c-.7-.4-1.3-.3-1.7 0l10 10.1L17 8.5z" />
    </svg>
);

/**
 * Google Play badge (official look: black, colourful triangle, two-line text).
 * variant 'md' = full badge, 'sm' = compact pill for banners.
 */
export default function PlayBadge({ variant = 'md' }) {
    if (variant === 'sm') {
        return (
            <a
                data-testid="play-badge-sm"
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
                className="shrink-0 inline-flex items-center gap-1.5 bg-[#111214] text-white border border-white/25 px-3 py-1.5 rounded-full text-xs font-semibold hover:border-white/50 transition-colors"
            >
                <Triangle size={13} /> Google Play
            </a>
        );
    }
    return (
        <a
            data-testid="btn-playstore"
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-3 bg-[#111214] text-white border border-white/25 px-5 py-2.5 rounded-2xl hover:border-white/50 hover:opacity-95 transition-all"
        >
            <Triangle size={24} />
            <span className="text-left leading-tight">
                <span className="block text-[10px] uppercase tracking-wider text-white/85">Get it on</span>
                <span className="block text-lg font-semibold -mt-0.5 text-white">Google Play</span>
            </span>
        </a>
    );
}
